import { GetStaticProps } from 'next';
import React from 'react';

import { EfroOostInConvoWithOverviewSingleFieldsFragment, EfroOostInformationFieldsFragment } from 'api/graphql-types';
import client from 'api/apollo-client';
import { getServerPageGetEfroOostInConvoWithOverview } from 'api/graphql-helper';

import Layout from 'modules/layout/layout';
import { ModuleBuilder } from 'modules/module-builder/module-builder';
import { Head } from 'modules/head/head';
import IntroHeader from 'modules/intro-header/intro-header';

import { initialState as settingsInitialState } from 'redux/stores/settings';
import { initialState as inConvoWithInitialState } from 'redux/stores/in-convo-with';

import { getStrapiParametersFromContext } from 'utils/strapi-parameters';
import { EFRO_OOST_ROUTES } from 'constants/routes';
import { IBasePageProps } from 'types/page';

interface IEfroOostInConvoWithOverviewPageProps extends IBasePageProps {
	inConvoWithOverview?: EfroOostInConvoWithOverviewSingleFieldsFragment;
	pageInformation?: EfroOostInformationFieldsFragment;
}

const EfroOostInConvoWithOverviewPage = (props: IEfroOostInConvoWithOverviewPageProps): React.JSX.Element => {
	const modules = props.inConvoWithOverview?.modules || [];
	const seoModule = props?.inConvoWithOverview?.seo;

	return (
		<Layout navbar={props?.pageInformation?.navbar} footer={props?.pageInformation?.footer}>
			<Head seoModule={seoModule} seoParent={props.pageInformation?.seo} />
			<IntroHeader module={props?.inConvoWithOverview?.header} slug={EFRO_OOST_ROUTES.IN_CONVO_WITH.fullPath} />
			<ModuleBuilder modules={modules} slug={EFRO_OOST_ROUTES.IN_CONVO_WITH.fullPath} />
		</Layout>
	);
};

export const getStaticProps: GetStaticProps = async (ctx) => {
	try {
		const { locale, publicationState, draftMode } = getStrapiParametersFromContext(ctx);

		const result = await getServerPageGetEfroOostInConvoWithOverview(
			{ variables: { locale, publicationState } },
			client
		);
		const {
			efroOostInformation,
			efroOostInConvoWithOverview,
			efroOostInConvoWithArticles_connection: efroOostInConvoWithArticles
		} = result.props.data;

		if (efroOostInConvoWithOverview == null) {
			return {
				notFound: true
			};
		}

		return {
			props: {
				pageInformation: efroOostInformation?.data?.attributes,
				inConvoWithOverview: efroOostInConvoWithOverview.data?.attributes,
				initialReduxState: {
					settings: {
						...settingsInitialState,
						publicationState,
						draftMode,
						contentType: 'efro-oost-in-convo-with-overview',
						contentTypeId: efroOostInConvoWithOverview?.data?.documentId,
						showNeutralStyle: true,
						hideLanguageSwitcher: true,
						hideSearchbar: true,
						isSubsite: true
					},
					inConvoWith: {
						...inConvoWithInitialState,
						inConvoWithArticles: efroOostInConvoWithArticles?.data?.map((item) => item.attributes),
						totalInConvoWithArticles: efroOostInConvoWithArticles?.pageInfo?.total
					}
				}
			},
			revalidate: Number(process.env.NEXT_PUBLIC_REVALIDATE_TIME_IN_SECONDS)
		};
	} catch (error: any) {
		// eslint-disable-next-line no-console
		console.error('Error in EfroOost in gesprek met overview', error);

		return {
			notFound: true
		};
	}
};

export default EfroOostInConvoWithOverviewPage;
